import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryConstructionIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    optimizationId="tama-category-construction"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M2.55407 12.4174H9.02995C9.33588 12.4174 9.58382 12.6655 9.58382 12.9714V15.9184C9.58382 16.2244 9.33588 16.4724 9.02995 16.4724H2.55407C2.24804 16.4724 2 16.2244 2 15.9184V12.9714C2 12.6655 2.24804 12.4174 2.55407 12.4174Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M13.6999 8.26265V11.2097C13.6999 11.5156 13.4519 11.7637 13.1458 11.7637H6.67557C6.36964 11.7637 6.1217 11.5156 6.1217 11.2097V8.26265C6.1217 7.95672 6.36964 7.70868 6.67557 7.70868H13.1458C13.4519 7.70868 13.6999 7.95672 13.6999 8.26265Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M14.9131 7.70874H21.389C21.6949 7.70874 21.9428 7.95678 21.9428 8.26271V11.2097C21.9428 11.5157 21.6949 11.7637 21.389 11.7637H14.9131C14.607 11.7637 14.359 11.5157 14.359 11.2097V8.26271C14.359 7.95678 14.607 7.70874 14.9131 7.70874Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M17.8214 3.55397V6.501C17.8214 6.80693 17.5733 7.05498 17.2673 7.05498H10.797C10.4911 7.05498 10.2432 6.80693 10.2432 6.501V3.55397C10.2432 3.24804 10.4911 3 10.797 3H17.2673C17.5733 3 17.8214 3.24804 17.8214 3.55397Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M17.8214 12.9714V15.9184C17.8214 16.2244 17.5733 16.4724 17.2673 16.4724H10.797C10.4911 16.4724 10.2432 16.2244 10.2432 15.9184V12.9714C10.2432 12.6655 10.4911 12.4174 10.797 12.4174H17.2673C17.5733 12.4174 17.8214 12.6655 17.8214 12.9714Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M14.9131 17.126H21.389C21.6949 17.126 21.9428 17.3742 21.9428 17.6801V20.6271C21.9428 20.9331 21.6949 21.1811 21.389 21.1811H14.9131C14.607 21.1811 14.359 20.9331 14.359 20.6271V17.6801C14.359 17.3742 14.607 17.126 14.9131 17.126Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M13.6999 17.68V20.6271C13.6999 20.933 13.4519 21.1811 13.1458 21.1811H6.67557C6.36964 21.1811 6.1217 20.933 6.1217 20.6271V17.68C6.1217 17.3741 6.36964 17.126 6.67557 17.126H13.1458C13.4519 17.126 13.6999 17.3741 13.6999 17.68Z"
      fillRule="evenodd"
    />
  </Svg>
));

CategoryConstructionIcon.displayName = 'CategoryConstructionIcon';
